module.exports = __webpack_public_path__ + "static/gardener-lady-tablet-b2d01da0cc2eaee0ab1b5c548255c227.jpg";